import { useLocalStorage } from 'usehooks-ts';
import { Hex } from 'viem';
import { useAccount } from 'wagmi';
import { SchemaSubaccountDto } from '../generated/apiTypes';
import { localStorageKeys } from '../lib/localstorageKeys';

export const useSelectedSubaccount = () => {
  const [value, setValue, removeValue] = useLocalStorage<SchemaSubaccountDto | null>(
    localStorageKeys.selectedSubaccount,
    null
  );
  return { value, setValue, removeValue };
};

export const usePendingSubaccount = () => {
  const [value, setValue, removeValue] = useLocalStorage<Hex | null>(
    localStorageKeys.pendingSubaccount,
    null
  );
  return { value, setValue, removeValue };
};

export const useActiveSelectedSubaccount = () => {
  const { value } = useSelectedSubaccount();
  const { address } = useAccount();
  if (!address) {
    return null;
  }
  return value;
};
